import { useEffect } from 'react';

const toastStyles = {
  container: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxWidth: 400
  },
  toast: (type) => ({
    padding: '14px 18px',
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 500,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    animation: 'adminToastIn 0.25s ease',
    ...(type === 'success' && {
      background: '#e8f5e9',
      color: '#2e7d32',
      border: '1px solid #a5d6a7'
    }),
    ...(type === 'error' && {
      background: '#ffebee',
      color: '#c62828',
      border: '1px solid #ef9a9a'
    }),
    ...(type === 'info' && {
      background: '#e3f2fd',
      color: '#1565c0',
      border: '1px solid #90caf9'
    })
  })
};

/**
 * Un solo toast. Para múltiples, el padre puede mapear una lista.
 */
const AdminToast = ({ message, type = 'info', duration = 4000, onClose }) => {
  useEffect(() => {
    if (!duration || !onClose) return;
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [duration, onClose]);

  if (!message) return null;

  return (
    <>
      <div style={toastStyles.toast(type)} role="status" aria-live="polite">
        {message}
      </div>
      <style>{`
        @keyframes adminToastIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
};

export default AdminToast;
export { toastStyles };
